<template>
  <div
    id="form-search-popover"
    class="container-app-search">

    <!-- HEADER SECTION -->
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header">
      <h4 class="title-tab-experience-manager">ARTIFICIAL INTELLIGENCE</h4>
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            class="btn grey btn-import-form m__r--5"
            @click="openAdd">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <b-form
            inline
            @keypress.13.prevent="filter(filter_data)">
            <j-select
              v-model="select_type"
              :options="options_search"
              :error-required="false"
              placeholder="Filter By"
              class="m__r--5"/>
            <b-form-input
              ref="filterInput"
              v-model="filter_data"
              placeholder="Search"
              style="width: 250px; height: 35px"/>
          </b-form>
        </b-form>
      </div>
    </div>

    <!-- CONTENT SECTION -->
    <div class="studio-page-content">
      <v-server-table
        v-show="load_first"
        ref="aiTableComponent"
        :columns="columns"
        :options="table_options"
        class="jTable"
        @loading="loading"
        @loaded="loaded">

        <div
          slot="id"
          slot-scope="props"
          @click="openDetail(props.row)">
          {{ props.row.id }}
        </div>

        <div
          slot="name"
          slot-scope="props"
          @click="openDetail(props.row)">
          {{ props.row.name }}
        </div>

        <div
          slot="data_manager_name"
          slot-scope="props"
          @click="openDetail(props.row)">
          {{ props.row.data_manager_name }}
        </div>

        <div
          slot="created_at"
          slot-scope="props"
          @click="openDetail(props.row)">
          {{ convertTimestamp(props.row.created_at) }}
        </div>

        <div
          slot="updated_at"
          slot-scope="props"
          @click="openDetail(props.row)">
          {{ convertTimestamp(props.row.updated_at) }}
        </div>

      </v-server-table>
      <jLoadingTable v-if="!load_first"/>
    </div>

    <b-popover
      ref="searchFormModal"
      :show.sync="popoverSearchShow"
      container="form-search-popover"
      target="targetSearch"
      placement="right">
      <div class="m__b--10">Search Data</div>
      <b-form
        inline
        @keypress.13.prevent="filter(filter_data)">
        <j-select
          v-model="select_type"
          :disabled="false"
          :options="options_search"
          class="m__r--5"/>
        <j-input
          v-model="filter_data"
          placeholder="Search"
          class="m__r--5"/>
        <b-button
          class="btn blue outline"
          style="margin-top: -19px;"
          @click="filter(filter_data)">
          <i class="fa fa-search bold" /> Search
        </b-button>
      </b-form>
    </b-popover>

    <b-modal
      ref="aiAddModal"
      class="mod-form modal-add-ai"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">CREATE AI MODEL</div>
      <b-form-group :class="{'error-input' : $v.ai_data.name.$error}">
        <label> AI Model Name </label>
        <j-input
          v-model="$v.ai_data.name.$model"
          :error-required="$v.ai_data.name.$error"
          :max-length="255"
          palceholder="Type Ai Model Name" />
      </b-form-group>

      <label> AI Purpose </label>
      <div class="container-type-list-options">
        <div
          :class="typeMode === 'classification' ? 'option-active' : ''"
          class="container-option text-align-center"
          @click="typeMode = 'classification'">
          <span class="text-option">Classification</span>
        </div>
        <div
          :class="typeMode === 'regression' ? 'option-active' : ''"
          class="container-option text-align-center"
          @click="typeMode = 'regression'">
          <span class="text-option">Regression</span>
        </div>
        <div
          :class="typeMode === 'clustering' ? 'option-active' : ''"
          class="container-option text-align-center"
          @click="typeMode = 'clustering'">
          <span class="text-option">Clustering</span>
        </div>
      </div>

      <b-form :class="{'error-input' : $v.ai_data.data_manager_id.$error}">
        <label> Dataset </label>
        <j-single-select
          v-model="$v.ai_data.data_manager_id.$model"
          :load-options="loadOptionsForm"
          :is-async="true"
          :cache-option="false"
          :placeholder="'Select Dataset'"
          value-format="object"
          label="name"/>
      </b-form>
      <br>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeAdd">
              Close
            </b-button>
            <b-button
              class="btn blue"
              @click="saveAi">
              Save
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';

import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jApiAi from '@/services/jApiAi';
import jwtDecode from 'jwt-decode';

export default {
  components: {
    jLoadingTable,
  },
  data() {
    return {
      popoverSearchShow: false,
      load_first: false,
      filter_data: '',
      select_type: 'name',
      data_table: [],
      typeMode: 'classification',
      ai_data: {
        name: '',
        data_manager_id: null,
      },
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      options_search: [
        {
          text: 'Id',
          value: 'id',
        },
        {
          text: 'Name',
          value: 'name',
        },
      ],
      columns: ['id', 'name', 'data_manager_name', 'created_at', 'updated_at'],
      table_options: {
        headings: {
          id: 'ID',
          name: 'MODEL',
          data_manager_name: 'DATASET',
          created_at: 'CREATED DATE',
          updated_at: 'UPDATE DATE',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        sortable: [],
        debounce: 1000,
        filterable: true,
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],

        requestAdapter(data) {
          return {
            pagination: {
              limit: data.limit,
              page: data.page,
              sort: data.sort,
              filter: data.filter,
            },
          };
        },
        requestFunction(data) {
          const list = jApiAi.getListAi(data.pagination);
          return list.catch((e) => {
            this.$store.commit('jStoreNotificationScreen/toggleProblem', e.message);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.count ? data.count : 0,
          };
        },
      },
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
  },
  watch: {
    filter_data(val) {
      if (val === '') {
        this.$refs.aiTableComponent.setFilter('');
      }
    },
  },
  mounted() {
    this.$refs.filterInput.focus();
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'showLoading', 'hideLoading']),
    ...mapActions('jStoreAi', ['createAi', 'deleteAi']),

    loading(val) {
      const a = val;
      const dataFilter = {
        // company_id: this.session.user.company_id,
      };
      if (this.filter_data) {
        if (this.select_type === 'name') {
          dataFilter.name = this.filter_data;
        } else {
          dataFilter.id = [this.filter_data];
        }
      }
      a.pagination.filter = JSON.stringify(dataFilter);
      a.pagination.sort = JSON.stringify({ updated_at: -1 });
      this.popoverSearchShow = false;
      if (this.load_first) {
        this.showLoading();
      }
    },
    loaded(data) {
      this.data_table = data.data;
      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },
    filter(val) {
      this.$refs.aiTableComponent.setFilter(val);
    },
    openDetail(data) {
      this.$router.push(`/ai/update/${data.id}`);
    },
    validateData() {
      this.$v.ai_data.$touch();
      return this.$v.ai_data.$error;
    },
    openAdd() {
      this.$refs.aiAddModal.show();
    },
    closeAdd() {
      this.ai_data.name = '';
      this.ai_data.data_manager_id = null;
      this.$refs.aiAddModal.hide();
    },
    saveAi() {
      if (!this.validateData()) {
        const param = {
          name: this.ai_data.name,
          purpose: this.typeMode,
          data_manager_id: this.ai_data.data_manager_id.id,
        };
        this.createAi(param).then((response) => {
          if (!response.data.error) {
            this.$router.push(`/ai/update/${response.data.id}`);
          }
        });
      }
    },
    convertTimestamp(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

        return `${years}-${mounth}-${dates} ${hours}:${minutes}`;
      }
      return null;
    },
    loadOptionsForm({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const dataFilter = {
            name: searchQuery,
            company_id: this.session.user.company_id,
            type: 'dataset',
          };
          const reqData = {
            limit: 50,
            page: 1,
            filter: JSON.stringify(dataFilter),
          };
          this.$store.dispatch('jStoreAutomation/getListForm', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },
  },
  validations() {
    return {
      ai_data: {
        name: {
          required,
        },
        data_manager_id: {
          required,
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ai/jAiList.vue